$eve_radio_group $eve_selection_single
	name <= group_name \
	attr *
		role \radiogroup
	sub /
		<= Layout $eve_flex
			direction \column
			sub <= Options /
				<= Option* $eve_radio_labelled
					name <= group_name
					value <= option_value*
					checked? <= option_selected*
					label <= option_label*
					event_click?event <=> option_click*?event
